import { LMFormatterService } from './lm-formatter.service';
import { LMConditionUtilService } from '@utils/lm-condition-util.service';

export const colSpan = (
  lmFormatterService: LMFormatterService,
  lmConditionUtilService: LMConditionUtilService,
  row: number,
  cell: number,
  value: any,
  columnDef: ListGridColumn,
  dataView: LMListDataView,
  dataGrid: SohoDataGridStatic
): number => {

  if (lmFormatterService.isTotalRow(dataView)) {
    const listGridComponent = dataGrid.settings.userObject();
    const dataViewSet = listGridComponent.dataViewSet;
    const gridColumns = dataGrid.settings.columns as Array<ListGridColumn>;

    const firstVisibleColumn = lmFormatterService.firstVisibleColumn(gridColumns, dataViewSet.header);
    if (firstVisibleColumn !== columnDef) {
      return 0;
    }

    let adjustment = (gridColumns[0] && gridColumns[0].id === 'selectionCheckbox') ? 1 : 0;

    for (let i = 0, len = gridColumns.length; i < len; i++) {
      const column = gridColumns[ i ];
      if (!column.displayField) {
        continue;
      }

      if (dataView.isSubtotalSummaryView) {
        return lmFormatterService.getColSpanForSubtotalSummaryRow(column, gridColumns, dataViewSet.header);
      }

      if (column.displayField.columnVisibility) {
        if (!lmConditionUtilService.isValid(column.displayField.columnVisibility, dataViewSet.header)) {
          adjustment = adjustment + 1;
          continue;
        }
      }

      if (lmFormatterService.isTotalColumn(column.fieldId, dataView, dataViewSet)) {
        return i - adjustment;
      }
    }
  }
  return 0;
};
